import { Classes, Dialog } from "@blueprintjs/core";
import { FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import { SuiviApprenantApi, SuiviApprenantFichierDto } from "../../../../../api";
import { FGWalterSelectInput, SmallFormGenerator } from "../../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../../hooks";
import { useReferential } from "../../../../../hooks/useReferential";
import { ETLCodes } from "../../../../../locales";

const StyledDialog = styled(Dialog)`
  width: 600px;
  height: auto;
  background-color: white;
`;

export interface ISuiviWalterDocumentEditDialogProps {
  idsuiviApprenantFichier: number;
  onClose: (refresh?: boolean) => void;
}

export const SuiviWalterDocumentEditDialog: React.FunctionComponent<ISuiviWalterDocumentEditDialogProps> = ({
  idsuiviApprenantFichier,
  onClose
}) => {
  const { t } = useTl();
  const api = useApiService(SuiviApprenantApi);

  const { data, loading, saveItem, saving, validationErrors } = useCrudApi(
    React.useMemo(
      () => ({
        getApiFn: () => {
          return api.suiviApprenantGetSuiviApprenantFichier({
            id: idsuiviApprenantFichier
          });
        },
        saveApiFn: async (d: SuiviApprenantFichierDto) => {
          return api.suiviApprenantSaveSuiviApprenantFichier({
            SuiviApprenantFichierDto: d
          });
        },
        onSaved: () => onClose(true)
      }),
      [api, idsuiviApprenantFichier, onClose]
    )
  );

  const FormSchema = React.useMemo(
    () =>
      Yup.object().shape({
        idtypeSuiviFichier: Yup.number().nullable()
      }),
    []
  );

  const [typesSuiviFichier, tLoading] = useReferential(a => a.referentialGetTypesSuiviFichier());

  return (
    <StyledDialog title={t(ETLCodes.UploadFichier)} isOpen={!!idsuiviApprenantFichier} onClose={() => onClose(false)}>
      <div className={Classes.DIALOG_BODY}>
        <SmallFormGenerator
          initialValues={data}
          onSubmit={saveItem}
          editMode={true}
          validationSchema={FormSchema}
          onCancel={() => onClose(false)}
          showDeleteButton={false}
          saving={saving}
          loading={loading}
          validationErrors={validationErrors}
        >
          <FieldGroup>
            <FGTextInput name="fileName" label={t(ETLCodes.Fichier)} readonly />
            <FGWalterSelectInput
              name="idtypeSuiviFichier"
              label={t(ETLCodes.Type)}
              items={typesSuiviFichier}
              loading={tLoading}
            />
          </FieldGroup>
        </SmallFormGenerator>
      </div>
    </StyledDialog>
  );
};
